export const TITLE_COMPANY_MANAGEMENT = "Companies";
